<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="search-wrap">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="6" class="bottom">
          <el-input
            placeholder="请输入内容ID"
            v-model="operationTargetId"
          ></el-input>
        </el-col>
        <el-col :span="6" class="bottom">
          <el-date-picker
            v-model="times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="bottom">
          <el-input placeholder="请输入处理人" v-model="processUser"></el-input>
        </el-col>
        <!-- <el-col :span="6" class="bottom" >
          <el-select v-model="processStatus" placeholder="请选择处理状态">
            <el-option
              v-for="item in pstatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="6" class="bottom">
          <el-select v-model="processType" placeholder="请选择处理类型">
            <el-option
              v-for="item in ptypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" style="flex: 1; text-align: right">
          <div class="bottom">
            <el-button class="but" @click="getArticleList" type="primary">
              查询</el-button
            >
            <el-button class="but" @click="empty"> 重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="content-audit-tabel">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all">
          <span slot="label" class="slot-item">
            <span>全部</span><span>{{ allCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="未处理" name="unprocessed">
          <span slot="label" class="slot-item">
            <span>未处理</span><span>{{ unprocessedCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
        <el-tab-pane label="已处理" name="processed">
          <span slot="label" class="slot-item">
            <span>已处理</span><span>{{ processedCount }}</span>
          </span>
          <base-table
            :tableData="tableData"
            @handleClick="TabhandleClick"
          ></base-table>
        </el-tab-pane>
      </el-tabs>
    </div>

    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    ></pagination>
    <modal
      :isShow.sync="reasonFrom.seeReasonDialog"
      title="查看理由"
      width="414px"
      :isShowBtn="reasonFrom.isShowBtn"
      :btnText="reasonFrom.ordinaryBtnText"
      @clickHandler="viewReasonClick"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <div class="reasonDom">
          {{ reasonFrom.reason }}
        </div>
      </el-form>
    </modal>
  </div>
</template>

<script>
import baseTable from "../../../../components/baseTable";
import breadCrumb from "../../../../components/breadCrumb";
import pagination from "../../../../components/pagination";
import { pageOperationProcess, countProcessStatus } from "@/api/man";
import modal from "@/components/modal";
import { mapState } from "vuex";

export default {
  name: "contentfeedback",
  data() {
    return {
      activeName: "all",
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "文章ID",
            prop: "contentId",
          },
          {
            label: "文章标题",
            prop: "contentName",
          },
          {
            label: "文章类型",
            prop: "contentType",
          },
          {
            label: "作者",
            prop: "nickName",
            tableStatus: "nickName",
          },
          {
            label: "反馈时间",
            prop: "oldestFeedbackTime",
            tableStatus: "oldestFeedbackTime",
          },
          {
            label: "审核时间",
            prop: "processTime",
            tableStatus: "processTime",
          },
          {
            label: "审核人",
            prop: "processUser",
            tableStatus: "processUser",
          },
          {
            label: "状态",
            prop: "processType",
            tableStatus: "processType",
          },
        ],
        tableType: 16,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      operationTargetId: "", // 内容id
      times: [], // 时间
      processUser: "", // 处理人
      processStatus: -1, // 选中的处理状态
      pstatus: [
        // 处理状态
        { label: "全部", value: -1 },
        { label: "未处理", value: 0 },
        { label: "已处理", value: 1 },
      ],
      processType: -1, // 选中的处理状态
      ptypes: [
        // 处理类型
        { label: "全部", value: -1 },
        { label: "不做处理", value: 1 },
        { label: "下线内容", value: 2 },
      ],
      allCount: 0, // 全部
      unprocessedCount: 0, // 待审核
      isShowBtn: [true, true, false],
      btnText: ["驳回", "通过"],
      targetValue: null,
      reasonFrom: {
        seeReasonDialog: false,
        ordinaryBtnText: ["取消", "确认"],
        isShowBtn: [false, true], //弹窗是否能显示按钮
        reason: "",
      },
    };
  },
  components: {
    breadCrumb,
    baseTable,
    pagination,
    modal,
  },
  mounted() {
    this.getArticleList();
  },

  computed: {
    ...mapState(["imgHost", "userInfo"]),
  },
  methods: {
    empty() {
      this.paginationDataProduct.currentPage = 1;
      this.paginationDataProduct.pageSize = 10;
      this.processStatus = -1;
      this.processType = -1;
      this.times = [];
      this.operationTargetId = "";
      this.processUser = "";
      this.getArticleList();
    },
    handleClick(tab, event) {
      sessionStorage.setItem("activeName", tab.name);
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };

      if (this.activeName === "all") {
        this.processStatus = -1;
      } else if (this.activeName === "unprocessed") {
        this.processStatus = 0;
      } else if (this.activeName === "processed") {
        this.processStatus = 1;
      }
      this.getArticleList();
    },
    TabhandleClick(val) {
      if (val.type === "review") {
        console.log("id", val);
        // 跳转到文章编辑页面
        this.$router.push({
          path: `/contentAudit/contentFeedbackAudit`,
          query: {
            id: val.val.contentId,
          },
        });
      } else if (val.type === "reason") {
        console.log("valval", val);
        if (val.val.processRemark) {
          this.reasonFrom.reason = val.val.processRemark;
        }
        this.reasonFrom.seeReasonDialog = true;
      }
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.getArticleList();
    },

    //获取文章列表
    getArticleList() {
      let params = {
        tenantId: this.$commonJs.getTenantId(),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        operationTargetType: 1,
      };
      if (this.processStatus > -1) {
        params.processStatus = this.processStatus; // 处理状态，0未处理 1已处理
      }
      if (this.processType > -1) {
        params.processType = this.processType; // 处理类型，1,"暂不处理" 2,"下线内容"
      }
      if (this.times.length > 0) {
        // 处理时间
        params.processStartTime = this.times[0];
        params.processEndTime = this.times[1];
      }
      if (this.operationTargetId) {
        params.operationTargetId = this.operationTargetId;
      }
      if (this.processUser) {
        params.processUser = this.processUser;
      }
      console.log("getArticleList -- params", params);
      pageOperationProcess(params).then((res) => {
        console.log(
          "🚀 ~ file: contentFeedback.vue:228 ~ pageOperationProcess ~ res:",
          res
        );
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res?.data?.forEach((item) => {
          item.contentId = item.operationTargetId || "";
          item.contentName = item.contentBizDTO?.contentName || "";
          item.contentType = item.contentBizDTO?.contentType || "";
          item.nickName = item.contentBizDTO?.authors?.[0]?.authorName || "";
          console.log("item", item);
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
      });
      // 获取各个反馈状态的文章的数量
      countProcessStatus(params).then((res) => {
        console.log(
          "🚀 ~ file: contentFeedback.vue:242 ~ countProcessStatus ~ res:",
          res
        );
        res?.forEach((item) => {
          if (item.key == "ALL") {
            this.allCount = item.count;
          } else if (item.key == "PROCESSED") {
            this.processedCount = item.count;
          } else if (item.key == "UN_PROCESSED") {
            this.unprocessedCount = item.count;
          }
        });
      });
    },
    //查看理由
    viewReasonClick(arg) {
      this.reasonFrom.seeReasonDialog = false;
      this.reasonFrom.reason = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrap {
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 10px;
  .bottom {
    margin-top: 14px;

    .but {
      float: right;
      margin-left: 10px;
      padding-top: 10px !important;
    }
  }
}
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;
    .redTag {
      color: red;
    }
  }
}

:deep(.el-select) {
  width: 100%;
}

:deep(.el-date-editor) {
  width: 100%;
}

:deep(.el-time-panel .el-popper) {
  margin: 4px -23px !important;
}

// :deep(.but) {
//   padding-top: 10px !important;
// }
:deep(.el-cascader) {
  width: 100%;
  height: 32px;
}

:deep(.el-range-separator) {
  width: 20px !important;
}
.reasonDom {
  padding: 20px;
  text-align: center;
}
</style>
